import React from 'react';
import { formatter } from '../../HelperFunction';

const Price = (props) => {
	return (
		<div
			className="productPrice"
			style={{
				fontSize: props.fontSize ? props.fontSize : '14px',
				paddingTop: props.paddingTop ? props.paddingTop : '10px',
				fontWeight: 'bold',
				margin: '5px 0',
				color: props.color ? props.color : 'rgb(7, 155, 155)'
			}}
		>
			{props.title && props.title} &nbsp;
			{props.divider ? props.divider : ' '} &nbsp;
			{formatter.format(props.value)} &nbsp;
		</div>
	);
};

export default Price;
